export default __webpack_public_path__ + "static/media/ejs-svgrepo-com.3ffa267c.svg";